import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { primarySoft } from '../../../../../theme';

type OptionToggleGroupProps<T extends string | number> = {
  options: ReadonlyArray<{ id: T; label: string }>;
} & (
  | { multiple?: false; value: T | null; onChange: (value: T | null) => void }
  // Sélection multiple : plusieurs options cumulables
  | { multiple: true; value: T[]; onChange: (value: T[]) => void }
);

function OptionToggleGroup<T extends string | number>(props: OptionToggleGroupProps<T>) {
  const { options } = props;
  const theme = useTheme();

  return (
    <ToggleButtonGroup
      exclusive={!props.multiple}
      value={props.value}
      onChange={(_, next) => (props.multiple ? props.onChange(next ?? []) : props.onChange(next))}
      sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}
    >
      {options.map(option => (
        <ToggleButton
          key={option.id}
          value={option.id}
          sx={{
            whiteSpace: 'pre-line',
            lineHeight: 1.3,
            fontSize: '0.72rem',
            px: 1.5,
            py: 0.8,
            border: `1px solid ${theme.palette.divider} !important`,
            borderRadius: '8px !important',
            color: 'text.primary',
            textTransform: 'none',
            '&.Mui-selected': {
              backgroundColor: primarySoft(theme, 0.08),
              color: 'primary.main',
              borderColor: `${theme.palette.primary.main} !important`,
              fontWeight: 600,
            },
            '&:hover': { backgroundColor: primarySoft(theme, 0.06) },
          }}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

export default OptionToggleGroup;
